import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("main", {
    staticClass: "banner-form"
  }, [_c("a-form", {
    attrs: {
      form: _vm.form
    }
  }, [_c("Card", {
    attrs: {
      title: _vm.$t("form.setting")
    }
  }, [_c("CardItem", {
    attrs: {
      title: _vm.$t("form.location")
    }
  }, [_c("a-select", {
    attrs: {
      mode: "multiple",
      placeholder: _vm.$t("form.placeSelectLocation")
    },
    model: {
      value: _vm.value.location,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "location", $$v);
      },
      expression: "value.location"
    }
  }, _vm._l(_vm.locationClient, function (item, i) {
    return _c("a-select-option", {
      key: i,
      attrs: {
        value: item.value
      }
    }, [_vm._v(" " + _vm._s(item.label) + " ")]);
  }), 1)], 1), _c("CardItem", {
    attrs: {
      title: _vm.$t("form.mobileBgColor")
    }
  }, [_c("ColorPicker", {
    model: {
      value: _vm.value.bgColor,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "bgColor", $$v);
      },
      expression: "value.bgColor"
    }
  })], 1), _c("CardItem", {
    attrs: {
      title: _vm.$t("form.pcBgColor")
    }
  }, [_c("ColorPicker", {
    model: {
      value: _vm.value.pcBgColor,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "pcBgColor", $$v);
      },
      expression: "value.pcBgColor"
    }
  })], 1), _c("CardItem", {
    class: {
      "location-disabled": !_vm.value.location.includes(2)
    },
    attrs: {
      title: _vm.$t("form.mHorizontailPadding"),
      layout: "vertical"
    }
  }, [_c("InputBar", {
    attrs: {
      min: 0,
      max: 24,
      suffix: "px"
    },
    model: {
      value: _vm.value.mHorizontalPadding,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "mHorizontalPadding", $$v);
      },
      expression: "value.mHorizontalPadding"
    }
  })], 1), _c("CardItem", {
    class: {
      "location-disabled": !_vm.value.location.includes(1)
    },
    attrs: {
      title: _vm.$t("form.pcHorizontailPadding"),
      layout: "vertical"
    }
  }, [_c("InputBar", {
    attrs: {
      min: 0,
      max: 24,
      suffix: "px"
    },
    model: {
      value: _vm.value.pcHorizontalPadding,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "pcHorizontalPadding", $$v);
      },
      expression: "value.pcHorizontalPadding"
    }
  })], 1)], 1), _c("Card", {
    attrs: {
      title: _vm.$t("form.contentSetting")
    }
  }, [_c("CardItem", {
    attrs: {
      layout: "vertical"
    }
  }, [_c("a-alert", {
    attrs: {
      message: _vm.$t("com.dragSort"),
      "show-icon": ""
    }
  })], 1), _c("ImgListPdf", {
    staticStyle: {
      "margin-bottom": "24px"
    },
    attrs: {
      id: _vm.id
    },
    model: {
      value: _vm.value.pathLink,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "pathLink", $$v);
      },
      expression: "value.pathLink"
    }
  }), _c("SubCard", {
    class: {
      "location-disabled": !_vm.value.location.includes(1)
    },
    attrs: {
      title: _vm.$t("form.PCMedia")
    }
  }, [_c("CardItem", {
    attrs: {
      title: _vm.$t("form.oneLineNum"),
      layout: "vertical"
    }
  }, [_c("InputNumber", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      min: 1,
      max: 6
    },
    model: {
      value: _vm.value.pcSizeNum,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "pcSizeNum", $$v);
      },
      expression: "value.pcSizeNum"
    }
  })], 1), _c("CardItem", {
    attrs: {
      title: _vm.$t("form.ImageSpacing"),
      layout: "vertical"
    }
  }, [_c("InputBar", {
    attrs: {
      min: 0,
      max: 24,
      suffix: "px"
    },
    model: {
      value: _vm.value.pcBannerSpace,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "pcBannerSpace", $$v);
      },
      expression: "value.pcBannerSpace"
    }
  })], 1), _c("CardItem", {
    attrs: {
      title: _vm.$t("form.ImageVerticalSpacing"),
      layout: "vertical"
    }
  }, [_c("InputBar", {
    attrs: {
      min: 0,
      max: 24,
      suffix: "px"
    },
    model: {
      value: _vm.value.pcBannerVerticalSpace,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "pcBannerVerticalSpace", $$v);
      },
      expression: "value.pcBannerVerticalSpace"
    }
  })], 1), _c("CardItem", {
    attrs: {
      title: _vm.$t("form.Dynamic")
    }
  }, [_c("a-switch", {
    attrs: {
      "checked-children": _vm.$t("form.open"),
      "un-checked-children": _vm.$t("form.close")
    },
    model: {
      value: _vm.value.pcDynamic,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "pcDynamic", $$v);
      },
      expression: "value.pcDynamic"
    }
  })], 1), _c("CardItem", {
    attrs: {
      title: _vm.$t("form.BannerHeight"),
      layout: "vertical"
    }
  }, [_c("a-row", [_c("InputBarSelect", {
    attrs: {
      min: 93,
      max: 600,
      options: _vm.pcHeight
    },
    model: {
      value: _vm.value.pcHeight,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "pcHeight", $$v);
      },
      expression: "value.pcHeight"
    }
  })], 1)], 1)], 1), _c("SubCard", {
    class: {
      "location-disabled": !_vm.value.location.includes(2)
    },
    attrs: {
      title: _vm.$t("form.mobile")
    }
  }, [_c("CardItem", {
    attrs: {
      title: _vm.$t("form.oneLineNum"),
      layout: "vertical"
    }
  }, [_c("InputNumber", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      min: 1,
      max: 6
    },
    model: {
      value: _vm.value.mSizeNum,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "mSizeNum", $$v);
      },
      expression: "value.mSizeNum"
    }
  })], 1), _c("CardItem", {
    attrs: {
      title: _vm.$t("form.ImageSpacing"),
      layout: "vertical"
    }
  }, [_c("InputBar", {
    attrs: {
      min: 0,
      max: 24,
      suffix: "px"
    },
    model: {
      value: _vm.value.mBannerSpace,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "mBannerSpace", $$v);
      },
      expression: "value.mBannerSpace"
    }
  })], 1), _c("CardItem", {
    attrs: {
      title: _vm.$t("form.ImageVerticalSpacing"),
      layout: "vertical"
    }
  }, [_c("InputBar", {
    attrs: {
      min: 0,
      max: 24,
      suffix: "px"
    },
    model: {
      value: _vm.value.mBannerVerticalSpace,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "mBannerVerticalSpace", $$v);
      },
      expression: "value.mBannerVerticalSpace"
    }
  })], 1), _c("CardItem", {
    attrs: {
      title: _vm.$t("form.BannerHeight"),
      layout: "vertical"
    }
  }, [_c("a-row", [_c("InputBarSelect", {
    attrs: {
      min: 10,
      max: 400,
      options: _vm.mHeight
    },
    model: {
      value: _vm.value.mHeight,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "mHeight", $$v);
      },
      expression: "value.mHeight"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };